import { Guide } from "../components/guide"
import GameNavigation from "../components/navigator"
export const GuideScreen = () => {
    return (
        <>
            <GameNavigation />
            <Guide />
        </>
    )
}